module.exports = __webpack_public_path__ + "img/p7.55ae8cfa.png";